// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3dv0V","Logo":"Toolbar_Logo__2eZc2","DesktopOnly":"Toolbar_DesktopOnly__238TC"};